<template>
  <div class="top-container">
    <div class="tips-area">
      <div>{{ tabTips[activeTab] }}</div>
      <span v-if="activeTab === '2'">注意：人员新增或调动后，请点击“<span class="area-bold">关联用户</span>”按钮关联用户ID。</span>
    </div>
    <div class="search-content">
      <div class="search-left">
        <!-- v-permission="butnPremission"  -->
         <template v-if="activeTab === '1'">
          <el-tooltip placement="top" v-if="batchUpdateTips.length > 0" v-permission="'userCheck:updateBasic'">
            <div slot="content" style="white-space: pre-line;">{{ batchUpdateTips }}</div>
            <butn  btntype="primary" title="批量更新" disabled @click="batchUpdate"></butn>
          </el-tooltip>
          <butn v-else btntype="primary" title="批量更新" v-permission="'userCheck:updateBasic'" @click="batchUpdate"></butn>
         </template>
        
        <butn btntype="primary" v-permission="'userCheck:export'" title="导出" @click="exportData"></butn>
        <butn v-if="activeTab === '1'" btntype="primary" title="一键更新排序" v-permission="'user:checkRecord:updateOrder'" @click="oneClickSort"></butn>
      </div>
      <div class="search-right">
        <el-form :inline="true" :model="filters" size="small">
          <el-form-item class="select_btn" v-if="activeTab === '1'">
            <el-select class="select_btn_style" v-model="filters.isUpdate" placeholder="更新状态" clearable>
              <el-option v-for="(item, i) in updateStatusData" :key="i" :label="item.paramValue"
                :value="item.paramKey"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="select_btn" v-if="activeTab === '2'">
            <el-select class="select_btn_style" v-model="filters.linkStatus" placeholder="关联状态">
              <el-option v-for="(item, i) in linkStatusData" :key="i" :label="item.paramValue"
                :value="item.paramKey"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-input class="name" prefix-icon="el-icon-search" v-model="filters.userName" placeholder="姓名"></el-input>
          </el-form-item>
          <el-form-item>
            <butn btntype="primary" title="查询" @click.native="searchHandle"></butn>
            <butn :title="'重置'" @click.native="resetData" class="czButn"></butn>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>

</template>
<script>
import { tabTips } from './constants'
import butn from "@/components/button/index"
export default {
  components: { butn },
  props: {
    activeTab: {
      type: String,
      default: '1',
    },
    batchUpdateTips: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      tabTips,
      filters: {},
      updateStatusData: [
        {
          paramKey: '1',
          paramValue: '未更新',
        },
        {
          paramKey: '2',
          paramValue: '已更新',
        },
      ],
      linkStatusData: [
        {
          paramKey: '0',
          paramValue: '未关联',
        },
        {
          paramKey: '1',
          paramValue: '已关联',
        },
      ],
    };
  },
  created() { },
  methods: {

    searchHandle() {
      this.$emit('search', this.filters);
    },

    resetData() {
      this.filters = {}
      this.searchHandle()
    },

    batchUpdate() {
      this.$emit('batchUpdate');
    },
    exportData() {
      this.$emit('exportData');
    },
    oneClickSort() {
      this.$emit('oneClickSort');
    },
  },
};
</script>
<style lang='scss' scoped>
.tips-area {
  font-size: 14px;
  color: #333;
  line-height: 26px;
  .area-bold {
    font-weight: bold;
  }
}

.search-content {
  margin-top: 16px;
  display: flex;
  justify-content: space-between;

  .name {
    margin-left: 10px;
    width: 160px;
  }
}
</style>